import { useState } from 'react';

type UserAvatarProps = {
  displayName: string | null | undefined;
  avatarUrl?: string | null;
  size?: 24 | 32 | 36 | 40 | 44 | 48 | 64 | 88 | 96 | 112 | 120;
  onClick?: () => void;
  ariaLabel?: string;
  shape?: 'circle' | 'rounded-square';
};

export function UserAvatar({ displayName, avatarUrl = null, size = 40, onClick, ariaLabel, shape = 'circle' }: UserAvatarProps) {
  const initial = displayName?.trim().slice(0, 1).toUpperCase() || 'Х';
  const [failedAvatarUrl, setFailedAvatarUrl] = useState<string | null>(null);
  const visibleAvatarUrl = shape === 'rounded-square' && avatarUrl === failedAvatarUrl ? null : avatarUrl;
  const content = visibleAvatarUrl
    ? <img src={visibleAvatarUrl!} alt="" aria-hidden="true" onError={shape === 'rounded-square' ? () => setFailedAvatarUrl(visibleAvatarUrl!) : undefined} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: shape === 'rounded-square' ? 8 : '50%' }} />
    : <span aria-hidden="true">{initial}</span>;
  const style = {
    width: size,
    height: size,
    minWidth: size,
    maxWidth: size,
    minHeight: size,
    maxHeight: size,
    flexShrink: 0,
    aspectRatio: '1 / 1',
    fontSize: Math.max(12, Math.round(size * 0.38)),
    overflow: 'hidden' as const,
    ...(shape === 'rounded-square' ? { borderRadius: 10, border: '2px solid #339999', boxSizing: 'border-box' as const, padding: 0 } : {}),
  };

  if (onClick) {
    return (
      <button
        className="social-avatar social-avatar--button"
        style={style}
        type="button"
        aria-label={ariaLabel ?? (displayName ? `Открыть профиль ${displayName}` : 'Открыть профиль')}
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  return (
    <span
      className="social-avatar"
      style={style}
      aria-label={displayName ?? 'Пользователь Хоппера'}
    >
      {content}
    </span>
  );
}
